<app-complex-modal-template
    [canConfirm]="fieldInterventionUpdateEndDateForm.valid"
    [stepNumber]="1"
    [title]="data.title | transloco"
    (onClickEvent)="onClickEvent($event)">
    <form [formGroup]="fieldInterventionUpdateEndDateForm">
        <div class="flex flex-row items-start w-full mt-6 mb-6">
            <div class="flex flex-col items-start w-80">
                <mat-label>{{ 'endDate' | transloco }}</mat-label>
                <mat-form-field
                    appearance="outline"
                    class="w-2/3"
                    subscriptSizing="dynamic">
                    <input
                        formControlName="scheduledEndDate"
                        matInput
                        [matDatepicker]="picker"
                        [matDatepickerFilter]="customDateAdapterService.datePickerFilter"
                        [placeholder]="dateFormatPlaceHolder" />
                    <mat-datepicker-toggle
                        matIconSuffix
                        [for]="picker" />
                    <mat-datepicker #picker />

                    @for (
                        error of fieldInterventionUpdateEndDateForm.controls.scheduledEndDate.errors | keyvalue;
                        track error
                    ) {
                        <mat-error>{{ formService.getErrorMessage(error) }}</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
    </form>
</app-complex-modal-template>
